<template>
  <StatusPopover
    title="Appointment Status"
    :status="status"
    :status-options="filterStatusOptions"
    @save-status="saveStatus"
    @update:status="$emit('update:status', $event)"
  >
    <template #default="{ changedStatus }">
      <q-item-wrapper
        v-if="canEdit && (status === 'SCHEDULED' || status === 'UNCONFIRMED')"
        clickable
        icon="mdi-calendar-remove"
        label="Mark as unscheduled"
        caption="The appointment will be placed in the unscheduled sidebar"
        icon-style="margin-left: -4px"
        @click="markAsUnscheduled"
      />

      <q-item-wrapper v-if="showNote && can(permissions.canAccessCalendar)" dense>
        <q-btn
          v-close-popup
          size="12px"
          label="Add Note"
          icon-right="mdi-clipboard-file-outline"
          color="blue"
          class="full-width"
          @click="$emit('focusOnNote')"
        />
      </q-item-wrapper>

      <q-item-wrapper v-if="changedStatus && (canSendMessage || can(permissions.canAccessCalendar))" dense>
        <q-btn
          v-close-popup
          size="12px"
          label="Notify Client"
          icon-right="mdi-message-plus"
          color="blue"
          @click="$emit('openManualReminder')"
        />
      </q-item-wrapper>

      <div class="q-pb-sm" />
    </template>
  </StatusPopover>
</template>

<script>
import StatusPopover from 'components/partials/StatusPopover'
import contextMenuMixin from '../mixins/contextMenuMixin'
import statusMixin from '../mixins/statusMixin'

/**
 * This component acts as the main popup for setting the status of an appointment
 */
export default {
  components: {
    StatusPopover
  },
  mixins: [statusMixin, contextMenuMixin],
  props: {
    id: {
      type: Number,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canSendMessage: {
      type: Boolean,
      default: false
    },
    hasClients: {
      type: Boolean,
      default: false
    },
    // Show option of sending a message after they have changed the status
    withSendMessage: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:status', 'focusOnNote', 'openManualReminder'],
  data () {
    return {
      showNote: false
    }
  },
  computed: {
    filterStatusOptions () {
      return this.baseStatusOptions(false, false)
    }
  },
  methods: {
    saveStatus (callback) {
      this.baseSetStatus(this.id, this.status, () => {
        if (this.status === 'DEPARTED_INCOMPLETE' || this.status === 'CANCELLED') {
          this.showNote = true
        }
        callback(this.withSendMessage && this.canSendMessage && this.hasClients)
      })
    },
    markAsUnscheduled () {
      this.baseMarkAsUnscheduled(this.id)
      this.$emit('update:status', 'UNSCHEDULED')
    }
  }
}
</script>
